:host {
  display: contents;

  nav {
    display: contents;
  }

  ul {
    all: unset;
    display: flex;
    gap: var-rem(--semantic-spacing-lg);
    align-self: stretch;

    @include media-header('until-md') {
      flex-direction: column;
      gap: var-rem(--semantic-spacing-xs);
    }

    @include media-header('md-lg') {
      gap: var-rem(--semantic-spacing-sm);
    }

    @include media-header('from-md') {
      margin-right: auto;
    }

    li {
      all: unset;
      display: contents;

      a {
        color: var(--semantic-color-text-default);
        cursor: pointer;
        position: relative;
        display: flex;
        gap: var-rem(--semantic-spacing-xs);
        align-items: center;
        justify-content: space-between;
        padding: var-rem(--semantic-spacing-xs) 0;
        font-size: wink-rem(1.8);
        text-decoration: none;

        &:focus {
          outline: none;
        }

        &:focus-visible {
          @include state-focus-outline;
          @include media-header('until-md') {
            margin: var-rem(--semantic-spacing-2xs);
          }
        }

        @include media-header('until-md') {
          font-family: var(--semantic-typography-font-family-primary), var(--font-fallbacks);
          font-weight: 700;
        }

        @include media-header('md-lg') {
          font-size: wink-rem(1.6);
        }

        @include media-header('from-md') {
          color: var(--semantic-color-text-subtle);

          &:hover,
          &[aria-expanded='true'] {
            color: var(--semantic-color-text-default);
          }

          &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: wink-rem(0.3);
            border-radius: wink-rem(0.3) wink-rem(0.3) 0 0;
            background-color: var(--wink-main-nav-link-after-bgc, unset);
          }

          &[aria-expanded='true'] {
            --wink-main-nav-link-after-bgc: var(--semantic-components-global-header-color-background-surface-menu-item-border);
          }

          &:focus-visible,
          &:hover {
            --wink-main-nav-link-after-bgc: var(--semantic-color-background-surface-bold-default);
          }

          &.active {
            --wink-main-nav-link-after-bgc: var(--semantic-components-global-header-color-background-menu-item-border);
          }

          wink-icon {
            display: none;
          }
        }
      }
    }
  }
}
